import axios from "axios";

export const apiInstance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	// baseURL: "https://api.lenco.co/web/v2/",
	withCredentials: true,
});
